import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-qr-generator',
    templateUrl: './qr-generator.component.html',
    styleUrls: ['./qr-generator.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class QrGeneratorComponent implements OnInit {
  @Input() orderId: string;
  elementType = 'img';
  value = 'id';
  id = '';

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {

    if(this.orderId == undefined) {
      this.getRoutesParams();
    } else {
      this.id = this.orderId;
    }

  }

  getRoutesParams() {
    this.id = this.route.snapshot.paramMap.get('id');
  }
}
 